// extracted by mini-css-extract-plugin
module.exports = {"hero":"SimpleHeroSection_hero__fMige","container":"SimpleHeroSection_container__1hhK1","faqIcon":"SimpleHeroSection_faqIcon__UEgcv"};